/**********************************************************************************************************************************
 * Revision History
 * 2024-08-05 TBH - Changed "CEU: course.CEU" to "ceu: course.ceu" and added "creditType: course.creditType" in bindCoursesList().
 * 2025-02-05 TBH - Added RequiredTextBooks and OptionalTextBooks List< CourseTextBook > properties.
 * 2025-02-05 TBH - Removed uneccessary mapping of response.courses to courses.
 * 2025-02-05 TBH - Removed formatText() method. Instead use Alpine JS x-html.
 * 2025-03-24 TBH - Refreshed from debug. Missing changes from 2/5.
 **********************************************************************************************************************************/
import { InstructorDetailsUrl } from "../directives/utilities/urls";

export default function studentCoursesByTerm() {
  return {
    studentTermsList: [],
    studentCoursesList: [],
    passedAcademicTerm: '',
    passedAcademicYear: '',
    passedRequestType: '',
    passedPeopleCodeId: '',
    selectedQuarter: [],
    addedCoursesList: [],
    waitListCoursesList: [],
    dropCoursesList: [],
    showErrorMesage: false,
    studentName: '',
    userName: '',
    showDiv:false,
    showLoader: false,
    seasonList: [],
    isQuarter: true,
    isQuarterMessage: '',
    quarterSelected:false,
    isDropCoursesAllowed:false,

    handleQuarterClick() {
      if( this.selectedQuarter != "" ) {
        this.isQuarter = true;
        this.isQuarterMessage = "";
        var parts = this.selectedQuarter.split( "/" );

        this.passedAcademicTerm = parts[ 1 ];
        this.passedAcademicYear = parts[ 0 ];
        this.quarterSelected = true;
        this.bindCoursesList();
      } else {
        this.isQuarter = false;
        this.isQuarterMessage = "Please select quarter/semester";
        this.quarterSelected = false;
      }
    },

    bindStudentTermsList() {
      fetch( '/api/StudentAPI/GetStudentSeasonsForMySchedule', { 
        "method":"GET" 
      }).then( response => {
        if (response.ok) {
          return( response.json())
        }
      }).then(response => {
        if (response != undefined && response.isSuccess) {
          Array.prototype.push.apply( this.studentTermsList, response.seasons );
          this.checkDropCoursesAllowed();
        } else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later."
        }
      });
    },

    formatDate( dateValue ) {
      if (dateValue != undefined && dateValue != "" && dateValue != null && dateValue != "N/A" && dateValue != 0) {
        const date = new Date( dateValue );
        const month = date.getMonth() + 1; // Month is zero-based, so add 1
        const day = date.getDate();
        const year = date.getFullYear();
        return( `${month}/${day}/${year}` );
      } else {
        return( dateValue );
      }
    },

    checkDropCoursesAllowed() {
      fetch( '/api/StudentAPI/CheckDropCoursesAllowed', { 
        "method": "GET" 
      }).then( response => {
        if (response.ok) {
          return( response.json())
        }
      }).then( response => {
        if( response != undefined && response.isSuccess ) {
          if( response.allowDropCourse ) {
            this.isDropCoursesAllowed = true;
          } else {
            this.isDropCoursesAllowed = false;
          }
        } else {
          this.showErrorMesage = "An unknown error has occurred. Please try again later."
        }
      });
    },

    bindCoursesList() {
      for( let i = 1; i < 4; i++ ) {
        fetch('/api/StudentAPI/GetCourses', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            AcademicYear: this.passedAcademicYear,
            AcademicTerm: this.passedAcademicTerm,
            RequestType: i,
          })
        }).then(response => {
          return( response.json());
        }).then( response => {

// console.log( 'response.courses: ' + JSON.stringify( response.courses ));

          if( i === 1 ) {
            this.addedCoursesList = response.courses;
          } else if( i === 2 ) {
            this.waitListCoursesList = response.courses;
          } else if( i === 3 ) {
            this.dropCoursesList = response.courses;
          }
        });
      }
    },

    getInstructorsDetailsPageUrl( item ) {
      if( item != null ) {
        return ( InstructorDetailsUrl + "?ref=" + item.id );
      }
    },

    init() {
      this.bindStudentTermsList();
    }
  }
}